// Sepet çekmecesi: "+N paket ekle" butonu, ödeme öncesi "kutunu büyüt" teklifi ve online ödeme indirimi.
// Çekmece AJAX ile yeniden çizildiğinde içindeki <script> çalışmaz; özel elemanlar her eklemede kendini kurar.
const vbCart = {
  root: () => window.Shopify?.routes?.root || '/',
  async add(items) {
    const drawer = document.querySelector('cart-drawer');
    const response = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items,
        sections: drawer ? drawer.getSectionsToRender().map((section) => section.id) : undefined,
        sections_url: window.location.pathname,
      }),
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'cart error');
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vb-cart', cartData: result });
    }
    if (drawer && result.sections) drawer.renderContents({ id: items[0].id, sections: result.sections });
    else window.location.reload();
    return result;
  },
};

if (!customElements.get('vb-cart-boost')) {
  customElements.define(
    'vb-cart-boost',
    class VbCartBoost extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-boost]');
        if (this.button) this.button.addEventListener('click', () => this.boost());
        this.querySelectorAll('[data-boost-variant]').forEach((chip) => {
          chip.addEventListener('click', () => {
            this.dataset.variant = chip.dataset.boostVariant;
            this.querySelectorAll('[data-boost-variant]').forEach((other) => other.setAttribute('aria-checked', other === chip));
            const image = this.querySelector('.vb-boost__media img');
            if (image && chip.dataset.boostImage) {
              image.removeAttribute('srcset');
              image.src = chip.dataset.boostImage;
            }
          });
        });
      }

      async boost() {
        this.button.disabled = true;
        this.button.classList.add('loading');
        try {
          await vbCart.add([{ id: parseInt(this.dataset.variant, 10), quantity: parseInt(this.dataset.add, 10) || 1 }]);
        } catch (error) {
          console.error(error);
          this.button.disabled = false;
          this.button.classList.remove('loading');
        }
      }
    }
  );
}

// "Kutunu büyüt": ödeme butonuna (online ya da kapıda ödeme) basınca, her paket sayısı için oturumda bir kez sorulur.
// Kabul: eksik paketler sepetteki model/bedenlerden sırayla eklenir, ardından aynı butona yeniden basılır.
const vbUpsell = {
  pass: false,
  triggers: '#rsi_buy_now_button, #CartDrawer-Checkout',
  key: (count) => `vb-upsell-${count}`,
  seen(count) {
    try {
      return sessionStorage.getItem(this.key(count)) === '1';
    } catch (error) {
      return false;
    }
  },
  markSeen(count) {
    try {
      sessionStorage.setItem(this.key(count), '1');
    } catch (error) {
      /* gizli sekme vb. */
    }
  },
  resume(selector) {
    this.pass = true;
    const target = document.querySelector(selector);
    if (target) target.click();
    this.pass = false;
  },
};

document.addEventListener(
  'click',
  (event) => {
    if (vbUpsell.pass) return;
    const trigger = event.target.closest(vbUpsell.triggers);
    if (!trigger || trigger.disabled) return;
    const offer = document.querySelector('cart-drawer vb-cart-upsell');
    if (!offer) return;
    const count = offer.dataset.count;
    if (vbUpsell.seen(count)) return;
    const dialog = offer.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    vbUpsell.markSeen(count);
    const selector = trigger.id === 'rsi_buy_now_button' ? '#rsi_buy_now_button' : '#CartDrawer-Checkout';
    dialog.showModal();

    const yes = dialog.querySelector('[data-upsell-yes]');
    const no = dialog.querySelector('[data-upsell-no]');
    const close = (go) => {
      dialog.close();
      if (go) vbUpsell.resume(selector);
    };
    no.onclick = () => close(true);
    dialog.oncancel = () => close(false);
    yes.onclick = async () => {
      yes.disabled = true;
      yes.classList.add('loading');
      const add = parseInt(offer.dataset.add, 10) || 0;
      let source = [];
      try {
        source = JSON.parse(offer.querySelector('[data-upsell-items]').textContent);
      } catch (error) {
        source = [];
      }
      // Sepetteki paketleri sırayla tekrarla (2 paketlik sepet 4'e çıkarken aynı seçim ikiye katlanır)
      const pool = source.flatMap((line) => Array(line.quantity).fill(line.id));
      if (!pool.length || !add) return close(true);
      const tally = new Map();
      Array.from({ length: add }, (_, index) => pool[index % pool.length]).forEach((id) =>
        tally.set(id, (tally.get(id) || 0) + 1)
      );
      try {
        await vbCart.add([...tally].map(([id, quantity]) => ({ id, quantity })));
        dialog.close();
        // Çekmece yeniden çizilsin, kapıda ödeme butonu yerine otursun; sonra ödemeye devam
        setTimeout(() => vbUpsell.resume(selector), 900);
      } catch (error) {
        console.error(error);
        close(true);
      }
    };
  },
  true
);

// Online ödeme indirimi: kodlu butona basınca ödeme sayfasına indirim koduyla gidilir (kapıda ödeme formu bu kodu almaz)
document.addEventListener('click', (event) => {
  const button = event.target.closest('#CartDrawer-Checkout[data-vb-discount], #checkout[data-vb-discount]');
  if (!button || button.disabled) return;
  event.preventDefault();
  button.classList.add('loading');
  window.location.href = `${vbCart.root()}checkout?discount=${encodeURIComponent(button.dataset.vbDiscount)}`;
});

// Ödeme sayfasından dönen müşterinin sepetinde online kod kalırsa kaldır: indirim yalnızca online butonundan geçerli olsun
(async () => {
  const button = document.querySelector('#CartDrawer-Checkout[data-vb-discount]');
  if (!button) return;
  const code = button.dataset.vbDiscount.toLowerCase();
  try {
    const cart = await (await fetch(`${vbCart.root()}cart.js`, { cache: 'no-store' })).json();
    if (!(cart.discount_codes || []).some((item) => String(item.code).toLowerCase() === code)) return;
    const response = await fetch(`${vbCart.root()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '', sections: 'cart-drawer' }),
    });
    const result = await response.json();
    const html = result.sections && result.sections['cart-drawer'];
    const current = document.querySelector('cart-drawer .drawer__inner');
    if (!html || !current) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    if (fresh) current.innerHTML = fresh.innerHTML;
  } catch (error) {
    console.error(error);
  }
})();

// Sepet şeridi: çubuk önceki yerinden yeni yerine kayar; yeni kademeye geçince kısa kutlama
if (!customElements.get('zz-cart-rail')) {
  customElements.define(
    'zz-cart-rail',
    class ZzCartRail extends HTMLElement {
      connectedCallback() {
        const fill = this.querySelector('[data-fill]');
        const pct = parseInt(this.dataset.pct, 10) || 0;
        const count = parseInt(this.dataset.count, 10) || 0;
        let last = pct;
        let lastCount = count;
        try {
          last = parseInt(sessionStorage.getItem('zz-rail-pct'), 10);
          lastCount = parseInt(sessionStorage.getItem('zz-rail-count'), 10) || 0;
          if (Number.isNaN(last)) last = 0;
          sessionStorage.setItem('zz-rail-pct', pct);
          sessionStorage.setItem('zz-rail-count', count);
        } catch (error) {
          last = pct;
          lastCount = count;
        }
        fill.style.width = `${last}%`;
        setTimeout(() => {
          fill.style.width = `${pct}%`;
        }, 60);
        if ((lastCount < 2 && count >= 2) || (lastCount < 4 && count >= 4)) this.celebrate();
      }

      celebrate() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const box = this.querySelector('[data-confetti]');
        box.innerHTML = Array.from({ length: 18 }, (_, index) => {
          const x = Math.round(Math.cos(index) * (40 + (index % 5) * 22));
          const y = -Math.round(24 + (index % 6) * 14);
          return `<i style="--x:${x}px;--y:${y}px;--d:${(index % 4) * 60}ms"></i>`;
        }).join('');
        setTimeout(() => {
          box.innerHTML = '';
        }, 1500);
      }
    }
  );
}

// Teslimat satırı: hafta içi 10:00'a kadar aynı gün kargoda, teslim 1-3 iş günü (kargo politikası)
if (!customElements.get('zz-eta')) {
  customElements.define(
    'zz-eta',
    class ZzEta extends HTMLElement {
      connectedCallback() {
        this.render();
        this.timer = window.setInterval(() => this.render(), 60000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      render() {
        const target = this.querySelector('[data-eta]');
        if (!target) return;
        const cutoff = 10;
        const fmt = (date, opts) => new Intl.DateTimeFormat('tr-TR', { timeZone: 'Europe/Istanbul', ...opts }).format(date);
        const isOff = (date) => ['Cmt', 'Paz'].includes(fmt(date, { weekday: 'short' }));
        const addDays = (date, n) => {
          const next = new Date(date);
          while (n > 0) {
            next.setUTCDate(next.getUTCDate() + 1);
            if (!isOff(next)) n -= 1;
          }
          return next;
        };
        const short = (date) => fmt(date, { day: 'numeric', month: 'short' });
        const now = new Date();
        const hour = parseInt(fmt(now, { hour: 'numeric', hourCycle: 'h23' }), 10);
        const minute = parseInt(fmt(now, { minute: 'numeric' }), 10);
        const today = !isOff(now) && hour < cutoff;
        const ship = today ? now : addDays(now, 1);
        const from = addDays(ship, 1);
        const to = addDays(ship, 3);
        const same = fmt(from, { month: 'short' }) === fmt(to, { month: 'short' });
        const range = same ? `${fmt(from, { day: 'numeric' })}-${short(to)}` : `${short(from)} - ${short(to)}`;
        let lead;
        if (today) {
          const left = (cutoff - hour) * 60 - minute;
          const time = left >= 60 ? `${Math.floor(left / 60)} sa ${left % 60} dk` : `${left} dk`;
          lead = `<strong>${time}</strong> içinde ver, <strong>bugün Aras Kargo'da</strong>`;
        } else {
          const day = short(ship) === short(new Date(now.getTime() + 864e5)) ? 'yarın' : fmt(ship, { weekday: 'long' }).toLocaleLowerCase('tr');
          lead = `Şimdi ver, <strong>${day} Aras Kargo'da</strong>`;
        }
        target.innerHTML = `${lead}, ${range} kapında`;
      }
    }
  );
}
